// @ts-nocheck
const formatDecimals = ({
  number,
  decimals,
}: {
  number: number;
  decimals: number;
}) => {
  return Number(number).toFixed(decimals);
};

export default formatDecimals;
